// extracted by mini-css-extract-plugin
export var green = "style-module--green--2acfb";
export var orange = "style-module--orange--c0a38";
export var purple = "style-module--purple--686a1";
export var revs = "style-module--revs--70f27";